import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState, forwardRef } from 'react';
import { string, bool, oneOfType, func, element, arrayOf, node, number } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import Flex from '../Flex';
import { Container, Header, Content, IconsContainer } from './accordion.styles';
import Heading from '../Heading';
const Accordion = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    asTitle,
    children,
    id,
    textAlign,
    openIcon,
    closeIcon,
    title,
    innerControl,
    open,
    fontSize,
    fontWeight,
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["asTitle", "children", "id", "textAlign", "openIcon", "closeIcon", "title", "innerControl", "open", "fontSize", "fontWeight", "onClick"]);

  const [show, setShow] = useState(false);
  const isText = typeof children === 'string';
  const showContent = innerControl ? show : open;
  const iconName = id ? `Category${id}` : undefined;

  const handleClick = () => {
    setShow(!show);
    onClick();
  };

  return /*#__PURE__*/React.createElement(Container, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(Header, {
    scale: "large",
    fill: "background.dark",
    endIcon: open ? closeIcon : openIcon,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "flex-start",
    alignItems: "center"
  }, iconName && /*#__PURE__*/React.createElement(IconsContainer, null, /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    fill: "background.primary"
  })), /*#__PURE__*/React.createElement(Heading, {
    as: asTitle,
    fontSize: fontSize,
    fontWeight: fontWeight
  }, title))), /*#__PURE__*/React.createElement(Content, {
    open: showContent,
    isText: isText,
    textAlign: textAlign
  }, children));
});
process.env.NODE_ENV !== "production" ? Accordion.propTypes = {
  name: string,
  id: string,
  asTitle: string,
  children: oneOfType([element, string, arrayOf(element), node]),
  textAlign: oneOfType([string, arrayOf(string)]),
  openIcon: string,
  closeIcon: string,
  title: string.isRequired,
  innerControl: bool,
  open: bool,
  fontSize: number,
  fontWeight: string,
  onClick: func
} : void 0;
Accordion.defaultProps = {
  asTitle: 'h2',
  children: null,
  textAlign: 'justify',
  openIcon: 'ChevronRight',
  closeIcon: 'ChevronRight',
  innerControl: false,
  open: false,
  fontSize: 2,
  fontWeight: 'medium'
};
Accordion.displayName = 'Accordion';
export default Accordion;